import * as React from 'react';
import { CardEvent } from 'src/store/events/types';
import { eventToCsvString } from 'src/utils/csvHelper';
import { formatDate } from 'src/utils/dateHelper';
import { IconPaths } from 'src/icons';

interface Props {
  event: CardEvent;
  style?: React.CSSProperties;
}

const onExport = (event: CardEvent) => {
  let csv = '';
  csv += eventToCsvString(event);
  if (navigator.msSaveBlob) {
    // IE 10+
    navigator.msSaveBlob(
      new Blob([csv], { type: 'text/csv;charset=utf-8;' }),
      `${event.title + '_' + formatDate(event.begins, 'DD.MM.YYYY')}.csv`
    );
  } else {
    const encodedUri = encodeURI(csv);
    const link = document.createElement('a');
    link.setAttribute('href', 'data:text/csv;charset=utf-8,%EF%BB%BF' + encodedUri);
    link.setAttribute(
      'download',
      event.title + '_' + formatDate(event.begins, 'DD.MM.YYYY') + '.csv'
    );
    document.body.appendChild(link);

    link.click();
    document.body.removeChild(link);
  }
};

const CSVExport: React.SFC<Props> = ({ event, style }: Props) => (
  <div className="pointer utilButton" style={style} onClick={() => onExport(event)}>
    <span>CSV Export</span>
    <img src={IconPaths['csv-icon']} />
  </div>
);

export default CSVExport;



// WEBPACK FOOTER //
// ./src/components/utils/CSVExport/CSVExport.tsx